<template>
    <div class="answer-box">
        <!-- 题干 -->
        <question :orgin-obj="orginObj"></question>
        <!-- 单选题 -->
        <div class="sigleSelect " v-if="orginObj.SubjectType === 1">
            <div class="topics">
                <div class="topicItem jf" v-for="(singleItem,index2) in orginObj.SubjectAnswerData"
                     :key="index2">
                    <div class="options xy-center cursor" :class="{'singleActive' : singleItem.IsRight}">
                        {{ opTab[index2] }}
                    </div>
                    <div class="content font-size14 cursor"
                         v-html="singleItem.Content">
                    </div>
                </div>
            </div>
        </div>
        <!-- 多选题 -->
        <div class="multiSelect " v-else-if="orginObj.SubjectType === 2">
            <div class="topics">
                <div class="topicItem jf" v-for="(singleItem,index2) in orginObj.SubjectAnswerData"
                     :key="index2">
                    <div class="options xy-center cursor multiple" :class="{'singleActive' : singleItem.IsRight}">
                        {{ opTab[index2] }}
                    </div>
                    <div class="content font-size14 cursor"
                         v-html="singleItem.Content"
                    ></div>
                </div>
            </div>
        </div>
        <!-- 填空题 -->
        <div class="fillBlank" v-else-if="orginObj.SubjectType === 3" style="margin-right: 40px">
            <div class="fillBlankItem" v-for="(singleItem,index2) in orginObj.SubjectAnswerData"
                 :key="index2">
                <div class="font-size14 c-333333 fillBlanktext">填空{{ index2 + 1 }}</div>
                <div class="fillBlankField">
                    <div v-html="singleItem.Content" class="tiankongcla"></div>
<!--                    <el-input     readonly v-model="singleItem.Content" rows="1" autosize-->
<!--                              type="textarea" placeholder="答案"></el-input>-->
                </div>
            </div>
        </div>
        <!-- 判断题 -->
        <div class="judgeTopic" v-else-if="orginObj.SubjectType === 4">
            <div class="topics">
                <div class="topicItem jf" v-for="(singleItem,index2) in orginObj.SubjectAnswerData"
                     :key="index2">
                    <div class="options xy-center cursor multiple " :class="{'singleActive' : singleItem.IsRight}">
                        {{ opTab[index2] }}
                    </div>
                    <div class="content font-size14 cursor"
                         v-html="singleItem.Content"
                    ></div>
                </div>
            </div>
        </div>
        <!-- 简答题 -->
        <div class="shortAnswer fillBlank" v-else-if="orginObj.SubjectType === 5" style="margin-right: 40px">
            <div class="fillBlankItem" v-for="(singleItem,index2) in orginObj.SubjectAnswerData"
                 :key="index2">
                正确答案：
                <div class="fillBlankField" style="margin-top: 10px">
                    <div v-html="singleItem.Content" class="tiankongcla"></div>
<!--                    <el-input readonly v-model="singleItem.Content" rows="1" autosize-->
<!--                              type="textarea" placeholder="答案"></el-input>-->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Question from "@/components/exam/Question";

let tabs = [];
for (let i = 0; i < 24; i++) {
    tabs.push(String.fromCharCode(65 + i))
}
export default {
    name: "QuestionShowB",
    components: { Question },
    props: {
        orginObj: Object
    },
    created() {
        // if( this.orginObj===null){}
        this.orginObj.RankNum = 1
    },
    data() {
        return {
            opTab: tabs
        }
    }
}
</script>

<style scoped lang="less">
.answer-box {
    .topicNav {
        margin-left: 0;
        margin-bottom: 37px;
    }
    .spin-title {
        background: #F4F5F6;
        padding-left: 30px;
        padding-top: 10px;
        padding-bottom: 10px;
        line-height: 1.5;
        margin-top: 21px;
    }

    .topics {

        .topicItem {
            margin-bottom: 20px;

            .options {
                width: 30px;
                height: 30px;
                border-radius: 50%;
                background: #FFFFFF;
                border: 1px solid #E5E8EC;
                margin-right: 10px;
            }

            .singleActive {
                background-color: #256CF4;
                color: white;
            }
            .multiple {
                border-radius: 6px;
            }
        }
    }

    .multiSelect .topics {
        .singleActive.makeRightStyle {
            background-color: #00B37C;
            color: white;
            border: 1px #00B37C solid;;
        }
    }

    .parsingBox {
        margin-top: 60px;
        width: 100%;
        border-radius: 8px;
        border: 1px solid #E5E8EC;
        min-height: 100px;
        padding: 30px;
        box-sizing: border-box;
        font-size: 14px;

        .showAnswerText {
            .lfet {
                .your {
                    margin-left: 70px;
                }
            }
        }

        .parsing {
            .tit {
                margin: 30px 0 20px 0;

                .cyc {
                    width: 5px;
                    height: 5px;
                    border-radius: 50%;
                    background: #256CF4;
                    margin-right: 8px;
                }
            }
        }
    }

    .notParsingBox {
        width: 100%;
        border-radius: 8px;
        // min-height: 218px;
    }

    .fillBlank {

        .fillBlankItem {
            margin-left: 51px;
            margin-right: 31px;

            .fillBlanktext {
                margin: 30px 0 20px 0;
            }

            ::v-deep .el-textarea__inner {
                min-height: 100px !important;
            }
        }

        .confrimBtn {
            width: 120px;
            height: 40px;
            background: #EEF4FF;
            border-radius: 8px;
            border: 1px solid #256CF4;
            color: #256CF4;
            margin: 40px 0;
        }
    }
    .tiankongcla{
        width: 100%;
        background: white;
        height: 0.5rem;
        padding: 0.06rem;
        border-radius: 0.04rem;
        overflow: auto;
        border: #c0c4cc solid 1px;
    }
}
</style>
